import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import {
fetchTodaySummary,
fetchPendingRequests,
fetchAllEmployees,
fetchAttendanceReport,
fetchAttendanceAnalyticsReport,
} from "../../AttendanceOverview/attendanceOverviewThunk";

import { loadAllNotifications } from "../../../store/commonThunks/notificationsThunk";
import { getPayrollSummary, getTodayCheckinsApi } from "../../../apiservice/hrpayroll";
import { fetchEmployees, fetchCurrentEmployee } from "../../../store/commonThunks/lookups";
import { selectCurrentEmployee, selectEmployees } from "../../../store/commonSelectors/lookupsSelectors";
import { selectAuthInfo } from "../../Auth/authSelectors";
import { fetchOnboardings } from "../../Onboarding/onboardingThunks";

export const useDashboardData = () => {

const dispatch = useDispatch();
const employeesFull = useSelector(selectEmployees);
const attendanceSummary = useSelector(s=>s.attendanceOverview.attendanceSummary);
const employees = useSelector(s=>s.attendanceOverview.employees);
const currentEmployee = useSelector(selectCurrentEmployee);
const attendanceReport = useSelector(s=>s.attendanceOverview.attendanceReport);
const onboardings = useSelector(s=>s.onboarding.list);

const expiries = useSelector(s=>s.notifications.expiryListHR);
const activities = useSelector(s=>s.notifications.activityListHR);
const notifications = useSelector(s=>s.notifications.list);
const authInfo = useSelector(selectAuthInfo);

const pendingRequests = useSelector(s=>s.attendanceOverview.pendingRequests);

const attendanceNotifications = useSelector((s)=>s.notifications?.attendanceListAll || []);

const notificationsCount = useSelector((s)=>s.notifications?.hrCount || 0);


const [todayData, setTodayData] = useState([]);
const [monthData, setMonthData] = useState([]);
const [monthlyTrendData, setMonthlyTrendData] = useState([]);
const [rangeType, setRangeType] = useState("month");
const [todayCheckins,setTodayCheckins] = useState([]);
const [analyticsMonth, setAnalyticsMonth] = useState(dayjs().format("MMMM"));
const [analyticsYear, setAnalyticsYear] = useState(dayjs().format("YYYY"));

const [payroll,setPayroll] = useState({
total_payrolls:0,
processed_payrolls:0,
pending_payrolls:0
});

const analyticsBaseDate = dayjs(
  `${analyticsYear}-${dayjs(analyticsMonth, "MMMM").format("MM")}-01`
);

useEffect(()=>{
dispatch(fetchOnboardings());
dispatch(fetchEmployees({notIncludeTerminated:true}));
dispatch(fetchTodaySummary({notIncludeTerminated:true}));
dispatch(fetchPendingRequests());
dispatch(fetchAllEmployees({notIncludeTerminated:true}));
dispatch(loadAllNotifications({}));

loadPayroll();
},[]);

useEffect(() => {
  let fromDate, toDate;

  if (rangeType === "today") {
    fromDate = dayjs().startOf("day").toISOString();
    toDate = dayjs().endOf("day").toISOString();
  }

  if (rangeType === "month") {
    fromDate = dayjs().startOf("month").toISOString();
    // Capped at today, not the full calendar month — otherwise future days
    // (including already-approved or pending leave requests dated later
    // this month) were being pulled in and counted as Absent/Pending
    // percentages for days that haven't happened yet.
    toDate = dayjs().endOf("day").toISOString();
  }

  dispatch(fetchAttendanceReport({ fromDate, toDate }))
    .then(res => setTodayData(res.payload?.data || []));

}, [rangeType]);

useEffect(() => {
  const baseDate = dayjs(
    `${analyticsYear}-${dayjs(analyticsMonth, "MMMM").format("MM")}-01`
  );

  dispatch(
    fetchAttendanceReport({
      fromDate: baseDate.startOf("month").toISOString(),
      toDate: baseDate.endOf("month").toISOString(),
    })
  ).then((res) => {
    setMonthlyTrendData(res.payload?.data || []);
  });
}, [dispatch, analyticsMonth, analyticsYear]);

useEffect(() => {
  const monthNumber = dayjs(analyticsMonth, "MMMM").format("MM");

  dispatch(
    fetchAttendanceAnalyticsReport({
      month: monthNumber,
      year: analyticsYear,
    })
  ).then((res) => {
    setMonthData(res.payload?.data || []);
  });
}, [dispatch, analyticsMonth, analyticsYear]);



useEffect(()=>{
 if(authInfo?.employee_id){
   dispatch(fetchCurrentEmployee(authInfo?.employee_id));
 }
},[dispatch, authInfo?.employee_id]);

const loadTodayCheckins = async () => {

const res = await getTodayCheckinsApi({});

if(!res.error){
setTodayCheckins(res.data?.data || []);
}

};

useEffect(()=>{
loadTodayCheckins();
},[]);

const loadPayroll = async () => {

const res = await getPayrollSummary({});
if(!res.error){  
setPayroll(res.data);
}

};



return {
  attendanceSummary,
  employees,
  employeesFull,
  currentEmployee,
  attendanceReport,
  onboardings,
  todayAttendanceReport: todayData,
  monthlyAttendanceReport: monthData,              
  monthlyTrendAttendanceReport: monthlyTrendData,
  analyticsMonth,
  setAnalyticsMonth,
  analyticsYear,
  setAnalyticsYear,
  setRangeType,
  rangeType,
  expiries,
  activities,
  notifications,
  attendanceNotifications,
  notificationsCount,
  pendingRequests,
  payroll,
  todayCheckins
};

};